import { render } from "./VisionFiveCharts.vue?vue&type=template&id=3422168d"
import script from "./VisionFiveCharts.vue?vue&type=script&lang=js"
export * from "./VisionFiveCharts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__